import { ref } from 'vue';
import {
  getLocalStorageValue,
  setLocalStorageValue,
} from '@/helpers/persistentStorage.js';

export const useLocalStorageHook = (key, initialValue) => {
  const state = ref();

  const setState = (newValue) => {
    setLocalStorageValue(key, newValue);

    state.value = newValue;
  };

  setState(getLocalStorageValue(key) ?? initialValue);

  return [state, setState];
};
